// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HHJ1","question":"styles_question__27JKt","description":"styles_description__1Fj8i"};